var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-group',[_c('label',{staticClass:"mb-1 text-lg d-flex align-items-center"},[_vm._v(" Danh mục tin tức ")]),_c('b-form-select',{attrs:{"options":_vm.options},model:{value:(_vm.entry.type),callback:function ($$v) {_vm.$set(_vm.entry, "type", $$v)},expression:"entry.type"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }